import datapoints from './datapoints';
import { deleteConversationsWithoutConfirmDialog } from './deleteConversations';
import { deleteItemsWithoutConfirmDialog } from './deleteItems';
import blockLastSendersHelper from './helpers/blockLastSendersHelper';
import { getSweepableMailboxesFromRowKeys } from './helpers/getSweepableMailboxes';
import getUniqueConversationContextsForRowKey from './helpers/getUniqueConversationContextsForRowKey';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
/**
 * Block the smtp addresses from given rows
 * @param rowKeys the row keys
 * @param tableView the table view
 * @param actionSource the action source that triggers the block action
 */
export default function blockLastSendersFromTable(rowKeys, tableView, actionSource) {
    if (!rowKeys || rowKeys.length == 0) {
        trace.error('Block button should not be exposed when there is nothing selected in list view.');
        return;
    }
    // Get de-duped mailboxes
    var mailboxes = getSweepableMailboxesFromRowKeys(rowKeys, tableView);
    blockLastSendersHelper(mailboxes, function () {
        deleteRowsUponBlocking(rowKeys, tableView, actionSource);
    });
}
/**
 * Delete the rows after the block last senders
 * @param rowKeys of the rows where the last senders are retrieved from
 * @param tableView that contains the rows
 */
var deleteRowsUponBlocking = action('deleteRowsUponBlocking', datapoints.blockSendersFromTableDatapoint)(function deleteRowsUponBlocking(rowKeys, tableView, actionSource) {
    // Since conversations may have been deleted from the table while the confirm dialog was open,
    // we need to validate the conversation rowKeys again before performing delete
    var filteredRowKeys = rowKeys.filter(function (rowKey) { return tableView.rowKeys.indexOf(rowKey) >= 0; });
    var disposableType = isControlFeatureEnabled('doc-consumerUrl')
        ? 'HardDelete'
        : 'MoveToDeletedItems';
    var instrumentationContexts = getInstrumentationContextsFromTableView(rowKeys, tableView);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            var conversationActionContexts = getUniqueConversationContextsForRowKey(filteredRowKeys, tableView.id);
            // VSO: 20069: [Discussion] Block Senders on a conversation
            // Permanently delete selected emails
            deleteConversationsWithoutConfirmDialog(conversationActionContexts, tableView.id, disposableType, instrumentationContexts, 'NonUserAction' /* actionSource */);
            break;
        case 1 /* Message */:
            var itemIdStrings = getRowIdsFromRowKeys(rowKeys, tableView.id);
            deleteItemsWithoutConfirmDialog(itemIdStrings, disposableType, tableView.tableQuery.folderId, 'NonUserAction' /* actionSource */, instrumentationContexts, null /* requestInitOptions */);
            break;
    }
});
//# sourceMappingURL=blockLastSendersFromTable.js.map